export default __webpack_public_path__ + "static/about-2-66833a98a4bc467137de0394002d1518.jpg";